import { render, staticRenderFns } from "./setSort.vue?vue&type=template&id=1cffd772&scoped=true"
import script from "./setSort.vue?vue&type=script&lang=js"
export * from "./setSort.vue?vue&type=script&lang=js"
import style0 from "./setSort.vue?vue&type=style&index=0&id=1cffd772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cffd772",
  null
  
)

export default component.exports